import * as Kinvey from './bundle';
export * from './bundle';
export { Kinvey };



// WEBPACK FOOTER //
// ./src/index.js